
import { defineComponent, ref } from "vue";
import Tab from '@/common-ui/tab/Tab.vue';
import NavMenu from "@/components/nav-menu";
import NavHeader from "@/components/nav-header";

import { ElConfigProvider } from "element-plus";

import zhCn from "element-plus/lib/locale/lang/zh-cn";

export default defineComponent({
  name: "Main",
  components: {
    NavMenu,
    NavHeader,
    [ElConfigProvider.name]: ElConfigProvider,
    Tab
  },
  setup() {
    const menuFold = ref(false);
    const changeMenuFold = (isFold: boolean) => {
      menuFold.value = isFold;
    };
    window.dispatchEvent(new Event('resize'))
    return {
      changeMenuFold,
      menuFold,
      zhCn
    };
  }
});
